import { SubstitutionReportType } from '@bp/planung-graphql-types';
import { Card, Grid, GridColumn, GridRow, LazyLoader, PdfIcon } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { SubstitutionStatisticReportsTable } from '../../../components/Substitutions/tables/SubstitutionStatisticReportsTable';
import { SubstitutionStatisticTypesTable } from '../../../components/Substitutions/tables/SubstitutionStatisticTypesTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SubstitutionsEvaluatePage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const permissions = usePermissionChecker();

  const [headline, setHeadline] = useState<string>(t('substitutions.statistics.pdfTotal'));
  const [subType, setSubType] = useState<SubstitutionReportType>(SubstitutionReportType.StatisticTotal);

  function handleSelect(subType: SubstitutionReportType, headline: string) {
    setHeadline(headline);
    setSubType(subType);
  }

  return (
    <Page
      isForbidden={!permissions?.canManageSubstitution()}
      title={`${t('substitutions.title', { count: 2 })} ${t('substitutions.evaluate').toLowerCase()}`}
    >
      <IconMenu className='mb-6'>
        <IconMenuItem
          label={t('substitutions.statistics.title', { count: 2 })}
          icon={<PdfIcon />}
          bubbleType={11}
          onClick={() => {
            // no op
          }}
          active={location.pathname.endsWith(t('routes.evaluate.slug'))}
        />
      </IconMenu>
      <Suspense fallback={<LazyLoader transparent size='xxl' forceHeight='50vh' />}>
        <Grid>
          <GridRow>
            <GridColumn width={6}>
              <Card header={{ headline: t('pdf.title', { count: 2 }) }} contentPadding={'none'}>
                <SubstitutionStatisticTypesTable onSelect={handleSelect} />
              </Card>
            </GridColumn>
            <GridColumn width={6}>
              <Card
                header={{
                  headline,
                }}
                contentPadding='none'
              >
                <SubstitutionStatisticReportsTable subType={subType} />
              </Card>
            </GridColumn>
          </GridRow>
        </Grid>
      </Suspense>
    </Page>
  );
};
